import { useItemSet } from '@exam-management/common/item-set-provider';
import { useQContent } from '@exam-management/common/qcontent-provider';
import { useMemo } from 'react';

import { ItemSetQuestionPreviewDialog } from '../../components';

interface SubQuestionPreviewModalProps {
  open: boolean;
  onClose: () => void;
}

export default function SubQuestionPreviewModal(props: Readonly<SubQuestionPreviewModalProps>) {
  const { open, onClose } = props;

  const { itemSet } = useItemSet();
  const { qContent } = useQContent();

  const { itemSetId, paragraph, totalQuestions } = useMemo(
    () => ({
      itemSetId: itemSet.id,
      paragraph: itemSet.metadata?.paragraph ?? '',
      totalQuestions: itemSet.totalQuestions ?? 0,
    }),
    [itemSet],
  );

  const { questionId, question, choices } = useMemo(
    () => ({
      questionId: qContent.id,
      question: qContent.details,
      choices: qContent.metadata.choices.map((choice) => ({
        label: choice.label,
        order: choice.order,
        isCorrect: choice.value === qContent.correctAnswer.value,
      })),
    }),
    [qContent],
  );

  return (
    <ItemSetQuestionPreviewDialog
      open={open}
      onClose={onClose}
      itemSetId={itemSetId}
      paragraph={paragraph}
      question={question}
      questionId={questionId}
      choices={choices}
      totalQuestions={totalQuestions}
    />
  );
}
